import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SplashScreen from "./screens/SplashScreen";
import LoginScreen from "./screens/LoginScreen";
import LandingScreen from "./screens/LandingScreen";
import FeedScreen from "./screens/FeedScreen";
import InboxScreen from "./screens/InboxScreen";
import SingleReservationScreen from "./screens/SingleReservationScreen";
import PrivateRoute from "./hoc/privateRoute";
import ThreadScreen from "./screens/ThreadScreen";
import AddReservationScreen from "./screens/AddReservation";
import ReservationsScreen from "./screens/ReservationsScreen";
import SingleUnitScreen from "./screens/SingleUnitScreen";
import PaymentScreen from "./screens/PaymentScreen";
import SuccessPaymentScreen from "./screens/PaymentSuccess";
import CancelPaymentScreen from "./screens/PaymentCancelled";
import ResultsScreen from "./screens/ResultsScreen";
import ProfileScreen from "./screens/Profile";
import GuidebookPreview from "./screens/GuidebookPreview";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SplashScreen />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <LandingScreen />{" "}
            </PrivateRoute>
          }
        />
        <Route path="/unit/:id" element={<SingleUnitScreen />} />

        <Route
          path="/reservations"
          element={
            <PrivateRoute>
              <ReservationsScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/explore"
          element={
            <PrivateRoute>
              <FeedScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/guidebooks/:guidebookUid/units/:unitUid"
          element={
            <PrivateRoute>
              <GuidebookPreview />
            </PrivateRoute>
          }
        />
        <Route
          path="/guidebooks/share/:shortCode"
          element={<GuidebookPreview />}
        />
        <Route
          path="/guidebooks/:guidebookUid"
          element={
            <PrivateRoute>
              <GuidebookPreview />
            </PrivateRoute>
          }
        />
        <Route
          path="/guidebooks/public/:shortCode"
          element={<GuidebookPreview />}
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfileScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/inbox"
          element={
            <PrivateRoute>
              <InboxScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/inbox/:id"
          element={
            <PrivateRoute>
              <ThreadScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/reservation/:id"
          element={
            <PrivateRoute>
              <SingleReservationScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/payment/:id"
          element={
            <PrivateRoute>
              <PaymentScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/reservation"
          element={
            <PrivateRoute>
              <SuccessPaymentScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/payment-canceled"
          element={
            <PrivateRoute>
              <CancelPaymentScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/results"
          element={
            <PrivateRoute>
              <ResultsScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-reservation"
          element={
            <PrivateRoute>
              <AddReservationScreen />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
